<template>
  <Popup style="height: 100%; width: 100%;" v-model="show" position="bottom" :round="false">
    <div class="agreement-popup">
      <NavBar
        :title="$t('appointment.visitors.agreementName')"
        left-text="返回"
        left-arrow
        fixed
        class="header"
        @click-left="onClickLeft"
      />
      <div style="height: calc(100% - 46px); padding-top: 46px;" class="content-wrap">
        <div class="content" v-html="agreement"></div>
      </div>
    </div>
  </Popup>
</template>

<script>
import { Popup, NavBar } from 'vant';
import agreement from './agreement';

export default {
  components: {
    Popup,
    NavBar,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      agreement,
    };
  },
  watch: {
    value(val) {
      this.show = val;
    },
    show(val) {
      this.$emit('input', val);
    },
  },
  methods: {
    onClickLeft() {
      this.show = false;
    },
  },
};
</script>

<style lang="less" scoped>
.agreement-popup {
  height: 100%;
}
.header {
  /deep/ .van-icon {
    color: #00ccbf;
  }
  /deep/ .van-nav-bar__text {
    color: #00ccbf;
  }
}
.content-wrap {
  overflow-y: auto;
  padding: 0 32px;
}
.content {
  padding: 32px 0;
  height: auto;
}
</style>
